var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocksquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gradient",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 426.78 71.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#393d3f;}.cls-1{stroke:#393d3f;stroke-miterlimit:10;stroke-width:0.25px;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.22,
    y1: 0.22,
    x2: 58.78,
    y2: 59.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008a7d"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blocksquare-2020-logo-gradient") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134,85.13v-47l5.24-.76V54.65h0.35a19.22,19.22,0,0,1,10.43-2.86c6.47,0,13.16,3.89,13.16,16.57v0.88c0,11.32-5.93,17.73-16.84,17.73C142.41,87,137,86.29,134,85.13Zm23.73-15.07V68.7c0-9.4-3.27-12.47-10.09-12.47a20.44,20.44,0,0,0-8.39,2.18v23a18.7,18.7,0,0,0,7.37,1.23C152.71,82.61,157.76,79.74,157.76,70.06Z",
    transform: "translate(-40.82 -26.15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.28,38.16l5.25-.76V86.22h-5.25V38.16Z",
    transform: "translate(-40.82 -26.15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.47,69.93v-1c0-10.7,6.2-17.11,15.34-17.11,9.54,0,15.34,6.2,15.34,16.91v1c0,10.77-6.27,17.18-15.41,17.18C190.2,86.84,184.47,80.7,184.47,69.93Zm25.36,0.34v-1.7c0-9.41-4.57-12.48-10.1-12.48-6.13,0-9.95,4.37-9.95,12.27v1.7c0,9.41,4.43,12.48,10.09,12.48C206,82.54,209.84,78.25,209.84,70.26Z",
    transform: "translate(-40.82 -26.15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.15,70V69c0-12,7.09-17.18,15.82-17.18,4.43,0,7.09.82,9.34,2.25v4.37a19.82,19.82,0,0,0-9.61-2.18c-6.14,0-10.16,4.15-10.16,11.93v1.64c0,8.66,3.61,12.55,10.84,12.55A18.25,18.25,0,0,0,246.65,80v4.23a18.3,18.3,0,0,1-9.88,2.66C227.08,86.84,221.15,81.11,221.15,70Z",
    transform: "translate(-40.82 -26.15)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.24,38.16l5.18-.76V86.22h-5.18V38.16ZM259,68.77l13.64-16.29h5.59L264.9,68.36l14.39,17.86h-6Z",
    transform: "translate(-40.82 -26.15)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284,84.38V80.23a24.76,24.76,0,0,0,10.15,2.12c5.38,0,7.57-1.91,7.57-5s-1.57-4.5-5.87-5.73l-3.34-.89c-4.91-1.36-8.24-3.61-8.24-9.34s3.75-9.62,11.52-9.62a19.27,19.27,0,0,1,9.21,2V58a21.94,21.94,0,0,0-8.94-1.77c-4.57,0-6.82,1.56-6.82,4.7,0,2.94,1.43,4.16,5,5.18l3.41,1c6.48,1.71,9.14,3.89,9.14,9.75,0,6.41-4.5,10-11.93,10A22.23,22.23,0,0,1,284,84.38Z",
    transform: "translate(-40.82 -26.15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.36,84h-0.27a16.36,16.36,0,0,1-9.61,2.8c-6.76,0-14.05-4.09-14.05-16.57V69.38C312.42,56,320,51.79,329,51.79a28.84,28.84,0,0,1,12.61,2.46V96.32l-5.25.76V84Zm0-4.37V57.25A22.42,22.42,0,0,0,328.65,56c-6.4,0-10.77,3.55-10.77,12.68v1.37c0,9.48,4,12.34,10.16,12.34A12.6,12.6,0,0,0,336.36,79.67Z",
    transform: "translate(-40.82 -26.15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351,76.95V52.4h5.24V76.2c0,4.36,1.57,6.14,6.54,6.14a21,21,0,0,0,9.41-2.67V52.4h5.18V86.22h-4.5l-0.47-3.07H372.1a19,19,0,0,1-10.77,3.68C354.71,86.84,351,83.49,351,76.95Z",
    transform: "translate(-40.82 -26.15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.43,77.36c0-5.93,3.82-9.06,10.3-9.82l9.13-1.09V62.91c0-5.25-2.31-6.62-8.38-6.62a28.36,28.36,0,0,0-8,1.1V53.63a25.58,25.58,0,0,1,10.09-1.84c7.44,0,11.6,3.06,11.6,10V86.22h-4.23l-0.55-2.93H404c-1.57,1.9-4.43,3.54-9,3.54C388.86,86.84,384.43,83.7,384.43,77.36Zm19.43,2.93v-10l-7.77.89c-4.15.41-6.2,2.12-6.2,6,0,3.67,2.52,5.52,6.41,5.52C399.43,82.75,402.43,81.73,403.86,80.29Z",
    transform: "translate(-40.82 -26.15)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.59,52.4h5v3.82h0.33a13.23,13.23,0,0,1,9.42-4.16,14.85,14.85,0,0,1,2,.14v4.71a17.91,17.91,0,0,0-2.46-.21,16,16,0,0,0-9.07,2.93V86.22h-5.25V52.4Z",
    transform: "translate(-40.82 -26.15)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.11,69.79V68.84c0-11.8,7-17.05,14.72-17.05,9.28,0,13.64,5.38,13.64,15.89v2.93h-23c0.27,8.46,4.29,11.73,11.53,11.73a23.07,23.07,0,0,0,10.56-2.52V83.7a20,20,0,0,1-11.39,3.14C444.5,86.84,439.11,80.36,439.11,69.79Zm5.32-3.34H462C462,59.09,459.23,56,453.7,56,449.47,56,445,58.47,444.43,66.45Z",
    transform: "translate(-40.82 -26.15)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52 52 20 52 20 59 59 59 59 0 0 0 0 59.88 7 66.88 7 7 52 7 52 20 52 52"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69 9.12 62 2.12 62 62 17 62 17 49 17 17 49 17 49 10 10 10 10 69 69 69 69 9.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksquare);
export default __webpack_public_path__ + "static/media/blocksquare.da5ae99b751c7e755d00d7a8eeb99763.svg";
export { ForwardRef as ReactComponent };